export const queryWithin = <T extends HTMLElement = HTMLElement>(
    wrapper: HTMLElement,
    selector: string,
): T | null => wrapper.querySelector<T>(selector);
